
    document.addEventListener('DOMContentLoaded', function() {
      // Load more functionality
      document.addEventListener('click', function(e) {        
        const loadBtn = e.target.closest('[data-load-more]');
        if (loadBtn) {
          e.preventDefault();

          const nextPage = parseInt(loadBtn.dataset.nextPage, 10);
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('page', nextPage);
          
          // Show loading state
          loadBtn.disabled = true;

          
          // Fetch the next page
          fetch(currentUrl.toString())
            .then(response => response.text())
            .then(html => {
              // Create a temporary div to parse the HTML
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = html;
              
              // Find the new articles container
              const newArticlesContainer = tempDiv.querySelector('.blogs-grid__blocks');
              const newLoadMoreContainer = tempDiv.querySelector('[data-load-more-container]');
              
              // Get current articles container
              const currentArticlesContainer = document.querySelector('.blogs-grid__blocks');
              const currentLoadMoreContainer = document.querySelector('[data-load-more-container]');
              
              if (newArticlesContainer && currentArticlesContainer) {
                // Append new articles to existing container
                currentArticlesContainer.innerHTML += newArticlesContainer.innerHTML;
                
                // Update or remove load more button
                if (newLoadMoreContainer) {
                  const newBtn = newLoadMoreContainer.querySelector('[data-load-more]');
                  if (newBtn && currentLoadMoreContainer) {
                    const currentBtn = currentLoadMoreContainer.querySelector('[data-load-more]');
                    currentBtn.dataset.nextPage = newBtn.dataset.nextPage;
                    currentBtn.innerHTML = newBtn.innerHTML;
                    currentBtn.disabled = false;
                  }
                } else if (currentLoadMoreContainer) {
                  // No more pages, hide the load more button
                  currentLoadMoreContainer.style.display = 'none';
                }
              }
            })
            .catch(error => {
              console.error('Error loading more articles:', error);
              // Reset button state on error
              loadBtn.disabled = false;
              loadBtn.innerHTML = loadBtn.dataset.originalText || 'Load more';
            });
        }
      });
    });
